export class Schedule {
    public static MONDAY: string = 'MONDAY';
    public static TUESDAY: string = 'TUESDAY';
    public static WEDNESDAY: string = 'WEDNESDAY';
    public static THURSDAY: string = 'THURSDAY';
    public static FRIDAY: string = 'FRIDAY';
    public static SATURDAY: string = 'SATURDAY';
    public static SUNDAY: string = 'SUNDAY';

    public static MON: string = 'MON';
    public static TUE: string = 'TUE';
    public static WED: string = 'WED';
    public static THU: string = 'THU';
    public static FRI: string = 'FRI';
    public static SAT: string = 'SAT';
    public static SUN: string = 'SUN';

    public id: string;
    public userId: string;
    public schedule: Array<ScheduleDay>;

    /**
     * Default Schedule: LUN - VIE
     *  08:30 - 12:30 / 14:00 - 18:00
     * @returns {Schedule} with id, userId equal to null
     */
    public static defaultSchedule(): Schedule {
        let schedule: Schedule = new Schedule();
        // 08:30-12:30
        let in_out1 = new ScheduleHour('08:30', '12:30');
        // 14:00 - 18:00
        let in_out2 = new ScheduleHour('14:00', '18:00');

        schedule.id = null;
        schedule.userId = null;
        schedule.schedule = [
            new ScheduleDay(this.MONDAY, [Schedule.clone(in_out1), Schedule.clone(in_out2)]),
            new ScheduleDay(this.TUESDAY, [Schedule.clone(in_out1), Schedule.clone(in_out2)]),
            new ScheduleDay(this.WEDNESDAY, [Schedule.clone(in_out1), Schedule.clone(in_out2)]),
            new ScheduleDay(this.THURSDAY, [Schedule.clone(in_out1), Schedule.clone(in_out2)]),
            new ScheduleDay(this.FRIDAY, [Schedule.clone(in_out1), Schedule.clone(in_out2)]),
            new ScheduleDay(this.SATURDAY, []),
            new ScheduleDay(this.SUNDAY, [])
        ];
        return schedule;
    }

    public static clone(object: any): any {
        return Object.assign({}, object);
    }
}

export class ScheduleDay {
    public day: string;
    public dayAbbr: string;
    public hours: Array<ScheduleHour>;

    constructor(_day: string, hours: Array<ScheduleHour>) {
        this.day = _day;
        switch (this.day) {
            case Schedule.MONDAY:
                this.dayAbbr = Schedule.MON;
                break;
            case Schedule.TUESDAY:
                this.dayAbbr = Schedule.TUE;
                break;
            case Schedule.WEDNESDAY:
                this.dayAbbr = Schedule.WED;
                break;
            case Schedule.THURSDAY:
                this.dayAbbr = Schedule.THU;
                break;
            case Schedule.FRIDAY:
                this.dayAbbr = Schedule.FRI;
                break;
            case Schedule.SATURDAY:
                this.dayAbbr = Schedule.SAT;
                break;
            case Schedule.SUNDAY:
                this.dayAbbr = Schedule.SUN;
                break;
        }
        this.hours = hours;
    }

    public static toString(hours: Array<ScheduleHour>): string {
        let list = [];
        hours.forEach(hour => {
            list.push(hour.in + '-' + hour.out);
        });
        return list.join(',');
    }

    public static toCsvString(hours: Array<ScheduleHour>): string {
        let list = [];
        hours.forEach(hour => {
            list.push(hour.in + '-' + hour.out);
        });
        return list.join(' - ');
    }
}

export class ScheduleHour {
    public in: string;
    public out: string;

    /**
     * @param {string} _in format HH:MM
     * @param {string} _out format HH:MM
     */
    constructor(_in: string, _out: string) {
        this.in = _in;
        this.out = _out;
    }
}



// WEBPACK FOOTER //
// ./src/models/Schedule.ts